import React from 'react';

interface IconTextItem {
    icon: string;
    alt: string;
    text: string;
}

interface IconTextProps {
    features: IconTextItem[];
    bgColorClass?: string;
}

const IconText: React.FC<IconTextProps> = ({ features, bgColorClass = 'bg-secondaryLight' }) => {
    return (
        <section className={`w-full py-12 ${bgColorClass}`}>
            <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 text-textColor">
                {features.map((feature, idx) => (
                    <div key={idx} className="flex items-start gap-4">
                        <img className="self-center" src={feature.icon} alt={feature.alt} loading="lazy" />
                        <p className="font-semibold">{feature.text}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default IconText;
